module.exports = __webpack_public_path__ + "img/Strub_Grey.56f7c393.png";